import { FC } from "react";
import { MDBFooter, MDBRow } from "mdb-react-ui-kit";
import FooterCopy from "./FooterCopy";
import FooterCta from "./FooterCta";
import FooterLinks from "./FooterLinks";
import FooterLogo from "./FooterLogo";
import style from "../../../styles/Footer.module.scss";
import FooterLinksMobile from "./FooterLinksMobile";

const FooterLayout: FC = () => {
    const year = new Date().getFullYear();

    return (
        <MDBFooter
            className={`${style.footBgColor} text-center minWidth100vwFromXL`}
        >
            <div
                style={{
                    padding: "1rem 5rem",
                }}
            >
                <section>
                    <div className="text-center text-md-start mt-sm-5">
                        <MDBRow className="mt-sm-3">
                            <FooterLogo />
                            <FooterLinks />
                            <FooterLinksMobile />
                            <FooterCta />
                        </MDBRow>
                    </div>
                </section>
            </div>
            <FooterCopy year={year} />
        </MDBFooter>
    );
};

export default FooterLayout;
